// ─── STATUS DE SEGUIMIENTO DE UNA ORDEN DE COMPRA ───────────────────────────
// En el orden del proceso. Lo usan Órdenes de compra (menú desplegable) y
// Pedidos (para ver en qué va la OC de cada pedido). Se guarda por orden en
// oc_workbooks.ocs_status.
export const STATUS_OC = [
  { id: "pendiente", label: "Pendiente", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  { id: "enviada", label: "Enviada", cls: "bg-sky-100 text-sky-800 border-sky-300" },
  { id: "produccion", label: "En producción", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  { id: "lista", label: "Lista", cls: "bg-violet-100 text-violet-800 border-violet-300" },
  { id: "embarcada", label: "Embarcada", cls: "bg-blue-100 text-blue-800 border-blue-300" },
  { id: "arribada", label: "Arribada", cls: "bg-teal-100 text-teal-800 border-teal-300" },
  { id: "entregada", label: "Entregada", cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
];
export const statusOC = (id) => STATUS_OC.find((x) => x.id === id) || STATUS_OC[0];

// "2026-10-03T…" → "03/10/2026"
export const fechaStatus = (iso) =>
  iso ? new Date(iso).toLocaleDateString("es-MX", { day: "2-digit", month: "2-digit", year: "numeric" }) : "";
